import { IconClose } from '@purpur/library/icon/close';
import styled from 'styled-components';

import {
    getPurpurBorder,
    getPurpurColor,
    getPurpurMotion,
    getPurpurSpacing,
    getPurpurTypography,
} from '@telialt/common-theme/src/purpurSelectors';

export const IconX = styled(IconClose).attrs({ size: 'xs' })`
    display: none;
    margin: auto 0 auto ${getPurpurSpacing('100')};
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: ${getPurpurColor('backgroundInteractivePrimary')};
`;

export const CapsuleShapedCheckbox = styled.div`
    display: inline-block;
    position: relative;

    label {
        position: relative;
        display: inline-flex;
        align-items: center;
        user-select: none;
        cursor: pointer;
        padding: calc(0.625rem - ${getPurpurBorder('widthXs')})
            calc(${getPurpurSpacing('200')} - ${getPurpurBorder('widthXs')});
        border: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('borderWeak')};
        border-radius: ${getPurpurBorder('radiusMd')};
        background: ${getPurpurColor('backgroundSecondary')};
        color: ${getPurpurColor('textInteractivePrimary')};
        font-family: ${getPurpurTypography('familyDefault')}, Helvetica, Arial, 'Lucida Grande', sans-serif;
        font-size: ${getPurpurTypography('scale100')};
        line-height: ${getPurpurTypography('lineHeightLoose')};
        font-weight: ${getPurpurTypography('weightNormal')};
        transition:
            background ${getPurpurMotion('duration100')} ease,
            color ${getPurpurMotion('duration100')} ease,
            border-color ${getPurpurMotion('duration100')} ease;

        &:hover {
            border-color: ${getPurpurColor('borderInteractivePrimaryHover')};
            background: ${getPurpurColor('backgroundInteractiveTransparentHover')};
            color: ${getPurpurColor('textInteractivePrimaryHover')};
        }
        &:active {
            border-color: ${getPurpurColor('borderInteractivePrimaryActive')};
            background: ${getPurpurColor('backgroundInteractiveTransparentActive')};
            color: ${getPurpurColor('textInteractivePrimaryActive')};
        }
    }

    input {
        opacity: 0;
        position: absolute;
        inset: 0;
        margin: 0;
    }
    input:checked {
        ~ label {
            ${IconX} {
                display: flex;
            }
            font-weight: ${getPurpurTypography('weightMedium')};
            border-color: ${getPurpurColor('borderInteractiveSelected')};
            &:hover {
                background: ${getPurpurColor('backgroundInteractiveTransparentHover')};
            }
            &:active {
                background: ${getPurpurColor('backgroundInteractiveTransparentActive')};
            }
            &::after {
                content: '';
                position: absolute;
                top: -${getPurpurBorder('widthXs')};
                bottom: -${getPurpurBorder('widthXs')};
                left: -${getPurpurBorder('widthXs')};
                right: -${getPurpurBorder('widthXs')};
                border: ${getPurpurBorder('widthSm')} solid ${getPurpurColor('borderInteractiveSelected')};
                border-radius: ${getPurpurBorder('radiusMd')};
            }
        }
    }
    input:disabled {
        ~ label {
            background: ${getPurpurColor('backgroundSecondary')};
            color: ${getPurpurColor('textWeak')};
            border-color: ${getPurpurColor('borderMedium')};
            cursor: not-allowed;
            filter: grayscale(100%);
            opacity: 0.5;

            &:hover {
                background: ${getPurpurColor('backgroundSecondary')};
            }
        }
    }
    input:disabled:checked {
        ~ label {
            border-color: transparent;
            background: ${getPurpurColor('backgroundSecondary')};
            color: ${getPurpurColor('textWeak')};
        }
    }

    input:focus:not(:focus-visible) {
        outline: 0;
    }
    input:focus:focus-visible ~ label::after {
        content: '';
        position: absolute;
        inset: calc(-1 * calc((${getPurpurBorder('widthSm')} * 2) + ${getPurpurBorder('widthXs')}));
        border-radius: ${getPurpurSpacing('150')};
        border: ${getPurpurBorder('widthSm')} solid ${getPurpurColor('borderInteractiveFocus')};
    }
`;
